<template>
  <div class="dashboard-container">
    <List/>
  </div>
</template>

<script>
import List from '@/views/Dashboard/Projects/List';

export default {
  name: 'FirstView',
  components: {List},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
.dashboard-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 40px;
}

.selector-container {
  display: flex;

  .select {
    max-width: 220px;
    width: 100%;
    border: 1px solid #eee;
    border-radius: 8px;
    margin: 12px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px 10px 32px;

    &:hover {
      background: #f1f1f1;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/FirstView.vue